export enum NotificationTypeEnum {
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP'
}


export interface IPhoneNotificationData {
  data: NotificationTypeEnum | null
  isLoading?: boolean
  isSuccess?: boolean
  updatePhoneNotification: (data: NotificationTypeEnum) => void
}